module.exports = __webpack_public_path__ + "static/img/西北政法大学.4bd4850.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/imgs/西北政法大学.jpg
// module id = /f7R
// module chunks = 1